require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./interviste-pietro-martinelli.json") })
        }
      }, "path---interviste-pietro-martinelli");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---interviste-pietro-martinelli!./.cache/json/interviste-pietro-martinelli.json
// module id = 686
// module chunks = 231608221292675